import { createRouteRef, type RouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef: RouteRef = createRouteRef();

export const ARGUS_EVENTS_ENTITY_ROUTE = '/argus-events';
export const ARGUS_STACKS_ENTITY_ROUTE = '/argus-stacks';
